import type { PropsWithChildren } from "react";
import {
  IconNameEnum,
  useHotelsStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { PopoverTrigger } from "@radix-ui/react-popover";
import { useFilterList, HotelListSort } from "@tenant/hotels";
import { FilterPrice, Icon, Popover, PopoverContent } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./FilterList.module.scss";
import { InputButton } from "@/components/InputButton";

export type FilterListComponentProps = PlatformComponentProps;

export const FilterList = ({
  className,
  children,
}: PropsWithChildren<FilterListComponentProps>) => {
  const styles = useHotelsStyles(CoreHotelsComponent.FilterList, defaultStyles);
  const [block, cn] = useModuleBEM(styles, CoreHotelsComponent.FilterList);

  const {
    text,
    context: { priceRange, filterOptions },
    handlers: { onPriceChange },
  } = useFilterList();
  const filters = [
    {
      title: text.price.title,
      icon: IconNameEnum.dollar,
      component: (
        <FilterPrice
          label={text.price.description}
          isMinValueConfigurable
          minimumPrice={filterOptions.priceRange?.min}
          maximumPrice={filterOptions.priceRange?.max}
          initialValue={{ minPrice: priceRange.min, maxPrice: priceRange.max }}
          onFilterPriceChange={onPriceChange}
          className={cn("filter-popover")}
        />
      ),
    },
  ];

  const filterComponents = filters.map(({ title, component, icon }) => {
    return (
      <Popover key={`filter-${title}`}>
        <PopoverTrigger className={cn("filter-button")}>
          <InputButton icon={<Icon iconName={icon} />} title={title} />
        </PopoverTrigger>
        <PopoverContent>{component}</PopoverContent>
      </Popover>
    );
  });

  return (
    <div className={clsx(block, className)}>
      {filterComponents}
      <HotelListSort />
    </div>
  );
};
